import { useEffect, useState } from 'react'
import { useIntercom } from 'react-use-intercom'

interface Props {
  customAttributes: Record<string, any>
}

const useShowIntercom = ({ customAttributes }: Props) => {
  const [isIntercomOpen, setIsIntercomOpen] = useState(false)
  const { hide, isOpen, update, showNewMessage } = useIntercom()

  const openIntercom = (prePopulatedContent?: string) => {
    if (isOpen) return

    update({
      hideDefaultLauncher: false,
      customAttributes,
    })
    showNewMessage(prePopulatedContent)
    setIsIntercomOpen(true)
  }

  const enableIntercom = () =>
    update({
      hideDefaultLauncher: false,
      customAttributes,
    })

  // on tab close any open Intercom chat
  useEffect(() => {
    const handleBeforeUnload = () => {
      hide()
    }

    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [hide, isOpen])

  return {
    isIntercomOpen,
    enableIntercom,
    openIntercom,
    update,
  }
}

export default useShowIntercom
